import {
  CREATE_GRIEVANCE,
  GET_SINGLE_GRIEVANCE,
  GET_USER_GRIEVANCES,
  UPLOAD_GRIEVANCE_ATTACHMENT,
} from "../../constants/api_constants";
import { handleApi, handleFileUpload } from "../utils";

export const getUserGrievances = async () => {
  return handleApi("get", GET_USER_GRIEVANCES);
};

export const getSingleGrievance = async (id) => {
  return handleApi("get", `${GET_SINGLE_GRIEVANCE}/${id}`);
};

export const createGrievance = async (values) => {
  return handleApi("post", CREATE_GRIEVANCE, values);
};

export const uploadGrievanceAttachment = async (id, formData) => {
  return handleFileUpload(`${UPLOAD_GRIEVANCE_ATTACHMENT}/${id}`, formData);
};
